import React from "react";
import SurveyForm from "./components/SurveyForm";
import logo from "./assets/logo.png";
import "./components/Survey.css";
import { ToastContainer, toast } from 'react-toastify';

function App() {
  return (
    <div>
      <div className="logo-div"><img src={logo} alt="Logo" className="survey-logo" /></div>
      <SurveyForm />
      <ToastContainer />
    </div>
  );
}

export default App;
